export default __webpack_public_path__ + "static/media/4700.479fe948.webp";